import { createFileRoute } from "@tanstack/react-router";
import { CTASection } from "~/components/landing/CTASection.tsx";
import { Footer } from "~/components/landing/Footer.tsx";
import { HeroSection } from "~/components/landing/HeroSection.tsx";
import { InsightSection } from "~/components/landing/InsightSection.tsx";
import { MethodologySection } from "~/components/landing/MethodologySection.tsx";
import { Navigation } from "~/components/landing/Navigation.tsx";
import { PersonasSection } from "~/components/landing/PersonasSection.tsx";

import personaWoman from "@assets/img/abstract_blue_rim_lit_woman_silhouette.png";
import heroBg from "@assets/img/abstract_diamond_facets_reflecting_fragmented_human_silhouettes_in_crimson_and_blue.png";
import personaMan from "@assets/img/abstract_red_rim_lit_man_silhouette.png";
import adventureBg from "@assets/img/subtle_fractal_pattern_of_a_woman_whispering_to_a_man.png";

export const Route = createFileRoute("/flirtmachine/")({
  component: FlirtMachineHome,
});

/**
 * FlirtMachine main site home page
 *
 * Domain routing is handled by TanStack Router's URL rewrite system.
 * ClawInstall home is at /clawinstall/index.tsx.
 *
 * @since 1.0.0
 */
function FlirtMachineHome() {
  return (
    <div className="min-h-screen bg-zinc-950 text-foreground font-sans selection:bg-primary/30 overflow-x-hidden">
      <Navigation />
      <HeroSection heroBg={heroBg} />
      <InsightSection adventureBg={adventureBg} />
      <MethodologySection />
      <PersonasSection personaMan={personaMan} personaWoman={personaWoman} />
      <CTASection />
      <Footer />
    </div>
  );
}
